module.exports = __webpack_public_path__ + "img/gitlab.d769a9d9.svg";